import BaseView from '../../core/baseView';

/**
 * add to wishlist view
 * responsible of handling add to wishlist button
 */
export default BaseView.extend({

    selectors: {
        wishlistIcon: '.wishlist-icon',
        wishlistIconActiveClass: 'wishlist-icon--active'
    },

    initialize: function () {
        this.listenTo(this.model, 'change:simpleSku', this.restoreButtonState);
    },

    restoreButtonState: function () {
        this.$el.find(this.selectors.wishlistIcon).removeClass(this.selectors.wishlistIconActiveClass);
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/pdp-new/addToWishlistView.js
 **/